import { useValidation } from "src/hooks";
import { checkQuestionIsSelect } from "../utils";
import { isConditionallyRequiredNonNull, isConditionallyRequiredNum, isConditionallyRequiredStr, isRequiredBool } from "src/utils/validationOptions";


export const useCreateSteps = () => {
    const {
        isRequired,
        isNonNull
    } = useValidation();


    const createGetStepsFn = (surveySteps, track) => {
        if (!surveySteps?.length) return

        const getSteps = (getValues) => {

            // const dataCollectionFields = {
            //     2: [
            //         { name: "fte", options: isRequired },
            //         { name: "employee-number", options: isRequired },
            //         { name: "fte-turnover", options: isNonNull },
            //         { name: "employee-turnover", options: isNonNull },
            //         { name: "non-employees", options: isNonNull },
            //         { name: "non-employees-included", options: isRequired },
            //         {
            //             name: "workforce-gender", options: {
            //                 validate: {
            //                     sum100: (v) => {
            //                         if (!v) return "Please enter value"
            //                         if (v === -1 || +v.female + +v.male + +v.other === 100) return true
            //                         return "Please enter values that sum to 100"

            //                     }
            //                 },
            //             }
            //         },
            //         {
            //             name: "leadership-gender", options: {
            //                 validate: {
            //                     sum100: (v) => {
            //                         if (!v) return "Please enter value"
            //                         if (v === -1 || +v.female + +v.male + +v.other === 100) return true
            //                         return "Please enter values that sum to 100"

            //                     }
            //                 },
            //             }
            //         },
            //         { name: "leadership-minority", options: isNonNull },
            //         { name: "leadership-disability", options: isNonNull },
            //         { name: "leadership-lgbtq", options: isNonNull },
            //         { name: "pay-gap", options: isNonNull },
            //         { name: "pay-gap-date", options: isRequired },
            //         { name: "di-training", options: isNonNull },
            //         { name: "workforce-minority", options: isNonNull },
            //         { name: "minority-classification", options: isRequired },
            //         { name: "employee-satisfaction", options: isNonNull },
            //         { name: "satisfaction-survey-date", options: isRequired },
            //     ]
            //     , 1: [{ name: "suppliers-minority", options: isNonNull },
            //     ],
            //     0: [
            //         { name: "assessed-ghg", options: isRequiredBool },
            //         { name: "ghg-assessment-year", options: isConditionallyRequiredNonNull(getValues, "assessed-ghg") },
            //         { name: "ghg-scope1", options: isConditionallyRequiredNonNull(getValues, "assessed-ghg") },
            //         { name: "ghg-scope2", options: isConditionallyRequiredNonNull(getValues, "assessed-ghg") },
            //         { name: "ghg-scope3", options: isConditionallyRequiredNonNull(getValues, "assessed-ghg") },
            //     ]
            // }



            const fields = Object.fromEntries(surveySteps.map((area, index) => {
                const key = index + 1

                const values = area.questions.filter(q => checkQuestionIsSelect(q)).map(q => ({ name: `${area.key}.${q.key}.score`, options: isRequired })) || []

                // const dataCollection = track === "validation" ? dataCollectionFields[index] : []

                // return [key, [...values, ...dataCollection || []]]

                return [key, values]
            }))

            // console.log("fields", fields)


            return fields
        }

        return getSteps

    }

    return { createGetStepsFn }
}

